const getQueryFromLocation = () => {
  try {
    const url = new URL(window.location.href)
    return (url.searchParams.get('query') || '').trim()
  } catch (_) {
    return ''
  }
}

const updateQueryHeader = () => {
  const container = document.querySelector('[data-role="collection-programs-query-header"]')
  if (!container) return

  const queryNode = container.querySelector('[data-role="collection-programs-query"]')
  if (!queryNode) return

  const query = getQueryFromLocation()

  if (!query) {
    container.hidden = true
    queryNode.textContent = ''
    return
  }

  container.hidden = false
  queryNode.textContent = query
}

const installLocationChangeEvents = () => {
  if (window.__tcLocationChangeEventsInstalled) return
  window.__tcLocationChangeEventsInstalled = true

  const fire = () => window.dispatchEvent(new Event('locationchange'))

  const { pushState, replaceState } = window.history
  window.history.pushState = function (...args) {
    const ret = pushState.apply(this, args)
    fire()
    return ret
  }
  window.history.replaceState = function (...args) {
    const ret = replaceState.apply(this, args)
    fire()
    return ret
  }

  window.addEventListener('popstate', fire)
}

document.addEventListener('DOMContentLoaded', function () {
  installLocationChangeEvents()
  updateQueryHeader()
  window.addEventListener('locationchange', updateQueryHeader)
})

